import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
import AuthModule from "./modules/auth";
import OrderModule from "@/store/modules/order";
import MenuModule from "@/store/modules/menu";
import OptionModule from "@/store/modules/option";
import MenuSetModule from "@/store/modules/menuSet";
import LanguageModule from "@/store/modules/language";
import SystemModule from "@/store/modules/system";
import HistoryModule from "@/store/modules/history";
import TableModule from "@/store/modules/table";
import CategoryModule from "@/store/modules/category";

Vue.use(Vuex);
const logrocketPlugin = createPlugin(LogRocket);
export const vuexStorageKey = "hayawazaVuex";

const debug = process.env.NODE_ENV !== "production";

function vuexPersistPatch() {
  return (store) => {
    store._vm.$root.$data["vue-persist-patch-delay"] = true;

    store.subscribe((mutation) => {
      if (mutation.type === "RESTORE_MUTATION") {
        store._vm.$root.$data["vue-persist-patch-delay"] = false;
        store._vm.$root.$emit("storageReady");
      }
    });
  };
}

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  restoreState: (key, storage) => {
    const state = storage.getItem(vuexStorageKey);
    const data = JSON.parse(state);

    return data;
  },
  key: vuexStorageKey,
});

const store = new Vuex.Store({
  modules: {
    Auth: AuthModule,
    OrderStore: OrderModule,
    CategoryStore: CategoryModule,
    MenuStore: MenuModule,
    OptionStore: OptionModule,
    MenuSetStore: MenuSetModule,
    LanguageStore: LanguageModule,
    SystemStore: SystemModule,
    HistoryStore: HistoryModule,
    TableStore: TableModule,
  },
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
  },
  plugins: [vuexLocal.plugin, vuexPersistPatch(), logrocketPlugin],
  strict: debug,
});

export default store;
